"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Farming = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Farming = (function (_super) {
    __extends(Farming, _super);
    function Farming() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.FARMING,
            tags: [Tags_1.Tags.PLANT],
            cost: 16,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.temperature(4); }),
            metadata: {
                cardNumber: '118',
                description: 'Requires +4° C or warmer. Increase your M€ production 2 steps and your plant production 2 steps. Gain 2 Plants.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.megacredits(2).br;
                        pb.plants(2);
                    }).nbsp.plants(2);
                }),
                victoryPoints: 2,
            },
        }) || this;
    }
    Farming.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        player.addProduction(Resources_1.Resources.PLANTS, 2);
        player.plants += 2;
        return undefined;
    };
    Farming.prototype.getVictoryPoints = function () {
        return 2;
    };
    return Farming;
}(Card_1.Card));
exports.Farming = Farming;
//# sourceMappingURL=Farming.js.map